import { Component, OnInit } from '@angular/core';

import 'rxjs/add/operator/switchMap';

import { MessageService }     from './message.service';

@Component({
	selector: 'reviews',
	templateUrl: './reviews.component.html',
	styleUrls: ['./reviews.component.css']
})

export class ReviewsComponent implements OnInit {

	constructor() {}

	ngOnInit(): void {
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/reviews.component.ts